import { render, staticRenderFns } from "./AddEditUser.vue?vue&type=template&id=3c97c9b5&scoped=true"
import script from "./AddEditUser.vue?vue&type=script&lang=js"
export * from "./AddEditUser.vue?vue&type=script&lang=js"
import style0 from "./AddEditUser.vue?vue&type=style&index=0&id=3c97c9b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97c9b5",
  null
  
)

export default component.exports